import { useRef } from "react"
import { useEffectButNotOnMount } from "./useEffectButNotOnMount"
import { useReloadKey } from "./useReloadKey"

/**
 * Produces a getter function for a value. The result will be memoized once
 * called. Updating the deps array will clear the cache and trigger a re-render.
 */
export function useLazyMemo<T>(fn: () => T, deps: unknown[]) {
  const [_, triggerReload] = useReloadKey()
  const cacheRef = useRef<T>()

  useEffectButNotOnMount(() => {
    cacheRef.current = undefined
    triggerReload()
  }, deps)

  function getValue() {
    if (!cacheRef.current) {
      cacheRef.current = fn()
    }
    return cacheRef.current
  }
  return getValue
}
